"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get down () {
        return down;
    },
    get up () {
        return up;
    }
});
const _globals = require("~/utils/globals");
const up = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.DASHBOARDS, (table)=>{
        table.string('uuid', 255).index('share_uuid_idx');
        table.string('password', 255);
        table.string('fk_custom_url_id', 20);
    });
};
const down = async (knex)=>{
    await knex.schema.alterTable(_globals.MetaTable.DASHBOARDS, (table)=>{
        table.dropColumn('uuid');
        table.dropColumn('password');
        table.dropColumn('fk_custom_url_id');
    });
};
